var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89137 21.4314C9.24006 21.9156 9.70488 22.311 10.2462 22.5842C10.7875 22.8573 11.3892 23 12 23C12.6108 23 13.2125 22.8573 13.7538 22.5842C14.2951 22.311 14.7599 21.9156 15.1086 21.4314L21.3209 12.8043C21.8819 12.0289 22.1081 11.0731 21.9516 10.1395C21.559 7.86503 20.3435 5.79876 18.5212 4.30834C16.699 2.81792 14.3882 2 12 2C9.61178 2 7.30101 2.81792 5.47877 4.30834C3.65653 5.79876 2.441 7.86503 2.04844 10.1395C1.89189 11.0731 2.1181 12.0289 2.67911 12.8043L8.89137 21.4314",
    stroke: "#251F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C14.2091 13 16 11.2091 16 9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9C8 11.2091 9.79086 13 12 13Z",
    stroke: "#251F2C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2a48e21b876d2585ea1787e35b9be2a9.svg";
export { ForwardRef as ReactComponent };